Flow.set('on', 'ready', function() {
  if(Flow.getExperience()) {
    const cartPage = document.getElementById('shopify-section-cart-template');
    const cartForm = document.getElementById('cart-form');

    if (cartPage) {
      console.log('Native Shopify Cart Page -- Cart V2');
      console.log('======  Localizing the Shopify Cart ======');
      
      function displayLocalizedElements() {
        const localizedElements = document.querySelectorAll('[data-flow-localize]');
      	localizedElements.forEach(function(element) {
            element.style.visibility = 'visible';
        });
      };
      
//       Flow.cart.getShopifyLocalizedCart({ 
//         success: (data) => Flow.cart.localize(), 
//         error: (error) => console.error(error) 
//       });
      
//       Flow.cart.localize().then(displayLocalizedElements());
      
//       Flow.cart.localize().then((data) => console.log('promise', data));
      
      Flow.cart.localize({
        success: (data) => console.log('success-callback', data),
        error: (error) => console.error(error)
      });
      
      if(cartForm) {
        const checkoutButton = document.getElementById('checkout_button');
        checkoutButton.addEventListener('click', function() {
          cartForm.addEventListener('submit', function(e) {
            e.preventDefault();
            Flow.checkout.redirect();
          });
        });
        
      };

    };
    
    function replaceReturnToCart(){
      console.log('replace')
      const topCartLink = document.querySelector('[data-automation-id=cart-breadcrumb] a')
      const lowerCartLink = document.querySelector('.customer-information-form__flat-cart-button')
      console.log('This is the lower Cart link ====>', lowerCartLink);
      if (topCartLink){
        let topParent = topCartLink.parentElement
        topCartLink.remove()
        topParent.innerHTML = '<a class="step__title" href="https://shopify.flow.io/cart"><span>Cart</span></a>'
      }
      if (lowerCartLink){
        console.log('lower cart Link');
        let lowerParent = lowerCartLink.parentElement
        lowerCartLink.remove()
        lowerParent.innerHTML = '<a class="button button button--flat-default button--medium customer-information-form__flat-cart-button" href="https://shopify.flow.io/cart"><span>Return to Cart</span></a>'
      }
    }
    
    Flow.set('on', 'pageview.checkout_step_1', function (data) {
      // handle cart updated event
      console.log(data);
      const deliveredDuty = data.order.delivered_duty;
      console.log('Delivered Duty ====>', deliveredDuty);
    });
    
    if(window.flow && window.flow.checkout) {
      const checkoutEnums = flow.checkout.enums.pageView;
      flow.checkout.onPageView(checkoutEnums.ALL, replaceReturnToCart);
    }
  };
  
});